import * as $   from "jquery";
import { Notifications } from "../../Core/Notifications";
import { $body } from "../../Core/Body";
import { getCurrentLanguage } from '../../Core/Languages';


export const GuestModal = (() => {

	const Selector = {
		MODAL                       : '#GuestModal',
		FORM                        : '#step2modalForm',
		CONTINUE_AS_GUEST_BTN       : '#continueAsGuestBtn',
		LOGIN_WHEN_USER_IS_GUEST_BTN: '#login-when-user-is-guest',
		REMIND_PASSWORD_BTN         : '#step2-remind-password',
		ALLOW_GUEST_CHECKER         : '#allowGuestContinue',
		LAST_STEP_BTN               : '#GuestExistCheck',		
	}

	function remindPassword(event) {
		event.preventDefault();
		const lang = getCurrentLanguage;
		$.post(`/${lang}/reset_password_ajax`, $(Selector.FORM).serialize(), json => {
			Notifications.add(json.msg, json.status === "success" ? "info" : "error", {lifespan: 10000});
		});
	}

	$body.on('click', Selector.REMIND_PASSWORD_BTN, remindPassword);
})();

export const setEmail = (email: string, selector: string) => {
	$(selector).val(email);
}

export const setFormSerialized = (FormSerialized: string, selector: string) => {
	$(selector).val(FormSerialized);
}

import * as $   from "jquery";
import { Notifications } from "../../Core/Notifications";
import { $body } from "../../Core/Body";
import { getCurrentLanguage } from '../../Core/Languages';


export const GuestModal = (() => {

	const Selector = {
		MODAL                       : '#GuestModal',
		FORM                        : '#step2modalForm',
		CONTINUE_AS_GUEST_BTN       : '#continueAsGuestBtn',
		LOGIN_WHEN_USER_IS_GUEST_BTN: '#login-when-user-is-guest',
		REMIND_PASSWORD_BTN         : '#step2-remind-password',
		ALLOW_GUEST_CHECKER         : '#allowGuestContinue',
		LAST_STEP_BTN               : '#GuestExistCheck',		
	}

	function remindPassword(event) {
		event.preventDefault();
		const lang = getCurrentLanguage;
		$.post(`/${lang}/reset_password_ajax`, $(Selector.FORM).serialize(), json => {
			Notifications.add(json.msg, json.status === "success" ? "info" : "error", {lifespan: 10000});
		});
	}

	$body.on('click', Selector.REMIND_PASSWORD_BTN, remindPassword);
})();

export const setEmail = (email: string, selector: string) => {
	$(selector).val(email);
}

export const setFormSerialized = (FormSerialized: string, selector: string) => {
	$(selector).val(FormSerialized);
}

